import { colorCSS } from "./colors";

//return black or white based on the best contrast for a given gradientId
export function gradientContrastCSS(gradientId: string, opacity = 1) {
    return gradientIsDark(gradientId)
        ? colorCSS("N0", opacity)
        : colorCSS("N900", opacity);
}

//return css string for gradient (todo support percentages, radial, repeating)
export function gradientCSS(gradientId?: string, angle = 0): string {
    if (gradientId && gradientExists(gradientId)) {
        const cssForStops: string = gradients[gradientId].colors
            .map((colorId) => colorCSS(colorId))
            .join(",");
        return `linear-gradient(${angle}deg, ${cssForStops}) no-repeat`;
    } else {
        return "transparent";
    }
}

//whether a gradient exists for a given id
export function gradientExists(gradientId?: string): gradientId is GradientId {
    return (
        typeof gradientId === "string" &&
        Object.keys(gradients).includes(gradientId)
    );
}

//whether a gradient is dark
export function gradientIsDark(gradientId: string): boolean {
    return gradientExists(gradientId) && gradients[gradientId].isDark;
}

export type GradientId = keyof typeof gradients;

//official list of gradients
export const gradients = {
    W500: { colors: ["M400", "R200"], isDark: true },
    W400: { colors: ["M300", "R100"], isDark: false },
    W300: { colors: ["M200", "Y100"], isDark: false },
    W200: { colors: ["M100", "Y50"], isDark: false },
    W100: { colors: ["M50", "N0"], isDark: false },
    WP500: { colors: ["P500", "M400"], isDark: true },
    WP400: { colors: ["P400", "M200"], isDark: true },
    WP300: { colors: ["P300", "M100"], isDark: true },
    WP200: { colors: ["P75", "M75"], isDark: false },
    WP100: { colors: ["P50", "N0"], isDark: false },
    CP500: { colors: ["P500", "N800"], isDark: true },
    CP400: { colors: ["P500", "B100"], isDark: true },
    CP300: { colors: ["P300", "T50"], isDark: false },
    CP200: { colors: ["P75", "B50"], isDark: false },
    CP100: { colors: ["T50", "N0"], isDark: false },
    C600: { colors: ["N900", "B500"], isDark: true },
    C500: { colors: ["T500", "N800"], isDark: true },
    C400: { colors: ["T400", "B500"], isDark: true },
    C300: { colors: ["T300", "B300"], isDark: false },
    C200: { colors: ["B75", "B50"], isDark: false },
    C100: { colors: ["B50", "N0"], isDark: false },
    S500: { colors: ["N800", "N600"], isDark: true },
    S400: { colors: ["N600", "N80"], isDark: true },
    S300: { colors: ["N300", "N50"], isDark: false },
    S200: { colors: ["B75", "N30"], isDark: false },
    S100: { colors: ["B40", "N0"], isDark: false }
} as const;
